export default "__VITE_ASSET__BQ6iZWni__"